/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CepLookupUpsertRequest {
  /**
   * Bairro retornado pelo ViaCEP
   */
  bairro: string;
  /**
   * CEP com ou sem hífen; zeros à esquerda são completados
   */
  cep: string;
  /**
   * Cidade retornada pelo ViaCEP
   */
  cidade: string;
  /**
   * Logradouro retornado pelo ViaCEP
   */
  logradouro: string;
  /**
   * UF retornada pelo ViaCEP
   */
  uf: string;
}
